@if (shouldShowDetails()) {
  <details class="navigation-mobile-item" name="navigation-mobile-item">
    <summary
      class="navigation-mobile-item__title d-flex justify-content-between align-items-center border-bottom p-2"
    >
      <span>{{ navigationItem().name }}</span>
      <fa-icon class="navigation-mobile-item__title-icon" icon="chevron-down" />
    </summary>
    <ul class="list-unstyled m-0">
      @for (child of navigationItem().children; track child.name) {
        <li class="m-0">
          <wl-nav-link
            (clicked)="navigate.emit()"
            class="d-flex ps-5 px-2 py-1 border-bottom"
            fullWidth
            [linkTitle]="child.name"
            [linkUrl]="child.path"
            wlAutomationId="navigation-mobile-child-link"
          />
        </li>
      }
    </ul>
  </details>
} @else {
  <wl-nav-link
    (clicked)="navigate.emit()"
    class="d-flex px-2 py-1 border-bottom"
    fullWidth
    [linkTitle]="navigationItem().name"
    [linkUrl]="navigationItem().path"
    wlAutomationId="navigation-mobile-parent-link"
  />
}
